/**
 * orga-app-api - vorlagen-v1-oa3_1
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface ZeitpunktTexte { 
    beginn: string;
    beginn_constant?: string;
    beginn_items?: Array<string>;
    einlass: string;
    einlass_constant?: string;
    einlass_items?: Array<string>;
}

